import connectionTypesActions from './actions';
import { ConnectionTypesState } from './types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ConnectionTypesState = {
  connectionTypes: [],
  connectionTypesError: null,
  connectionTypesLoading: false,
  connectionTypesIsEmpty: false,
};

export const connectionTypesSlice = createSlice({
  initialState,
  name: 'connectionTypes',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(connectionTypesActions.getConnectionTypes.pending, (state) => {
      state.connectionTypesLoading = true;
    });

    builder.addCase(connectionTypesActions.getConnectionTypes.fulfilled, (state, { payload: { connectionTypes } }) => {
      state.connectionTypesError = null;
      state.connectionTypesLoading = false;
      state.connectionTypes = connectionTypes;
      state.connectionTypesIsEmpty = !!!connectionTypes.length;
    });

    builder.addCase(connectionTypesActions.getConnectionTypes.rejected, (state, { error }) => {
      state.connectionTypesLoading = false;
      state.connectionTypesError = error;
    });
  },
});

export default connectionTypesSlice.reducer;
